import { Injectable } from '@angular/core';

import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
  Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { UsuarioService } from '../services/usuario.service';

@Injectable({ providedIn: 'root' })
export class DeslogadoGuard implements CanActivate {
  constructor(private router: Router, private usuarioService: UsuarioService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.usuarioService
      .getUsuario()
      .pipe(
        switchMap((usuario) => {
          if (usuario === null) {
            return of(true);
          } else {
            this.router.navigate(['/home']);
            return of(false);
          }
        })
      )
      .pipe(first());
  }
}
